import {Project} from '@catcore/types/api-v2';
import {ActionWithPayload} from '@catcore/types/base';
import * as projectDetailActions from '@catdetails/actions/project';

export interface State {
  project: object;
}

export const initialState: State = {
  project: null,
};

export function reducer(state: State = initialState, action: ActionWithPayload<Project>) {

  let returnable = state;

  switch (action.type) {
    case projectDetailActions.PROJECT_DETAILS_UNLOAD:
      returnable = {...state, project: null};
      state.project = null;
      break;
    case projectDetailActions.PROJECT_DETAILS_LOADED:
      returnable = {...state, project: action.payload};
      break;
  }
  return returnable;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/reducers/project.reducer.ts